"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _ProductPrice = _interopRequireDefault(require("@sprinx/react-com/ProductPrice"));

var _GridAreaContainer = _interopRequireDefault(require("@sprinx/react-mui-components/GridAreaContainer"));

var useStyles = (0, _styles.makeStyles)(function () {
  return (
    /* theme */
    {
      root: {}
    }
  );
}, {
  name: 'CartSummaryPrice'
});

function CartSummaryPrice(_ref) {
  var children = _ref.children,
      pClasses = _ref.classes,
      className = _ref.className,
      currency = _ref.currency,
      product = _ref.product,
      ProductPriceProps = _ref.ProductPriceProps,
      renderToGrigArea = _ref.renderToGrigArea,
      subjectPrice = _ref.subjectPrice,
      subjectPriceOriginal = _ref.subjectPriceOriginal,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["children", "classes", "className", "currency", "product", "ProductPriceProps", "renderToGrigArea", "subjectPrice", "subjectPriceOriginal"]);
  var classes = useStyles({
    classes: pClasses
  });
  return /*#__PURE__*/_react.default.createElement(_GridAreaContainer.default, (0, _extends2.default)({
    renderToGridArea: renderToGrigArea,
    className: (0, _clsx.default)(classes.root, className)
  }, rest), /*#__PURE__*/_react.default.createElement(_ProductPrice.default, (0, _extends2.default)({
    className: className,
    classes: classes,
    currency: currency,
    price: subjectPrice,
    product: product,
    priceOriginal: subjectPriceOriginal
  }, ProductPriceProps), children));
}

process.env.NODE_ENV !== "production" ? CartSummaryPrice.propTypes = {
  children: _propTypes.default.node,
  classes: _propTypes.default.shape({
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  currency: _propTypes.default.string.isRequired,
  product: _propTypes.default.shape({}),
  ProductPriceProps: _propTypes.default.shape({}),
  renderToGrigArea: _propTypes.default.string,
  subjectPrice: _propTypes.default.number,
  subjectPriceOriginal: _propTypes.default.number
} : void 0;
CartSummaryPrice.defaultProps = {
  children: undefined,
  classes: undefined,
  className: undefined,
  product: undefined,
  ProductPriceProps: undefined,
  renderToGrigArea: 'price',
  subjectPrice: undefined,
  subjectPriceOriginal: undefined
};
var _default = CartSummaryPrice;
exports.default = _default;